<table
  class="details-table"
  *ngIf="employment">
  <tr *ngIf="employment.organisation.address">
    <td class="detail-label">{{ ("details" | i18n) || "Details" }}</td>
    <td>
      {{ employment.organisation.address?.street }},
      {{ employment.organisation.address?.zip }}
      {{ employment.organisation.address?.location }}
    </td>
  </tr>

  <tr *ngIf="employment.description">
    <td class="detail-label">{{ ("description" | i18n) || "Beschreibung" }}</td>
    <td>{{ employment.description }}</td>
  </tr>
  <tr *ngIf="employmentCertificates$ | async as certificatesString">
    <td class="detail-label">
      {{ ("certificates" | i18n) || "Qualifikation" | titlecase }}
    </td>
    <td>{{ certificatesString }}</td>
  </tr>
  <tr *ngIf="customer?.name">
    <td class="detail-label">
      {{ ("offerFrom" | i18n) || "Angebot von" | titlecase }}
    </td>
    <td data-cy="customer-name-text">
      {{ customer?.name }}
    </td>
  </tr>
</table>
